import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_2 = { class: "w-full flex flex-wrap" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "w-full flex flex-wrap" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "ml-3" }, " Ao continuar, você concorda com nossa política de Cookies e termos de tratamento de dados de acordo com a nossa política de privacidade. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "ml-3",
    href: "https://moinhoglobo.com.br/politica-de-privacidade/",
    style: {"text-decoration":"underline","color":"blue"},
    target: "_blank"
  }, "https://moinhoglobo.com.br/politica-de-privacidade/")
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

import { novoMotorista } from "@/data/motorista";
import helpers from "@/helpers";
import store from "@/store";
import { Motorista } from "@/types/motorista";
import { Parceiro } from "@/types/parceiro";
import axios from "@/axios";
import { ref, Ref, computed, onMounted, inject } from "vue";
import FormValidated from "../FormValidated.vue";
import InputText from "../inputs/InputText.vue";
import InputCheck from "../inputs/InputCheck.vue";
import SelectInput from "../inputs/SelectInput.vue";
import Bobjeto from "../inputs/Bobjeto.vue";
import ListHeader from "../ListHeader.vue";
import DialogModal from "../Modal/DialogModal.vue";
import { FormValidatedUpdateKey } from "@/types/inject";


export default /*#__PURE__*/_defineComponent({
  __name: 'InformacoesMotorista',
  props: {
  tclass: String,
},
  setup(__props) {



const modalNovoMotoristaShow = ref(false);
const modalNovoMotorista: Ref<Motorista> = ref(novoMotorista());
const modalNovoMotoristaPasso = ref(1);

const usuario_externo = computed(() => store.state.acessos.usuario_externo);

const motoristas = computed(() => {
  if (!(store.state.motoristas ?? []).length) {
    return [
      {
        name: "Cadastre um motorista...",
        value: "",
        celular: "",
        ddi: "",
      },
    ];
  }

  const regs = (store.state.motoristas ?? []).map((i) => {
    return {
      name: i.razao_social,
      value: i.ukey as string,
      celular: i.celular,
      ddi: i.ddi ? i.ddi : null,
    };
  });

  return [
    {
      name: "Selecione...",
      value: "",
      celular: "",
      ddi: "",
    },
    ...regs,
  ];
});
const isLoading = ref(false);

const onUpdateMotorista = (event: any) => {
  const ukey = event?.target?.value;

  if (!ukey) {
    typeof onUpdate === "function" && onUpdate({ ["celular"]: "" });
    typeof onUpdate === "function" && onUpdate({ ["ddi"]: null });
    typeof onUpdate === "function" && onUpdate({ ["motorista"]: null });
    return;
  }

  const parceiro = motoristas.value.find((i) => i.value == ukey);

  if (!parceiro) {
    return;
  }

  typeof onUpdate === "function" && onUpdate({ ["celular"]: parceiro.celular });
  typeof onUpdate === "function" && onUpdate({ ["ddi"]: parceiro.ddi });
  typeof onUpdate === "function" && onUpdate({ ["motorista"]: parceiro.name });
};

// O Bobjeto (usuário interno) traz o parceiro completo, então o celular vem do
// contato profissional em vez da lista de motoristas vinculados.
const preencheDadosDoMotorista = (parceiro: Parceiro | null) => {
  const celular = parceiro?.contatosProfissionais?.[0]?.celular;

  if (!celular) {
    return;
  }

  typeof onUpdate === "function" && onUpdate({ ["celular"]: celular });
};

// A lista de vinculados só existe para o usuário externo; o interno pesquisa no
// cadastro completo pelo Bobjeto.
const carregaMotoristasVinculados = async () => {
  if (!usuario_externo.value) {
    return;
  }

  await store.dispatch("getMotoristas");
};

onMounted(async () => {
  await carregaMotoristasVinculados();
});

const onSubmitMotorista = async (values: Motorista) => {
  try {
    if (values.e_estrangeiro == 1 && !values.ddi) {
      helpers.mensagemErro(`Preencha o País do Celular.`);
      return;
    }
    if (values.e_estrangeiro == 0) {
      if (values.cpf_cnpj.length < 11) {
        helpers.mensagemErro("O CPF precisa ter ao menos 11 dígitos.");
        return;
      }
      if (values.celular.length < 10) {
        helpers.mensagemErro("O Celular precisa ter ao menos 10 dígitos.");
        return;
      }
    }
    isLoading.value = true;
    const motorista = await store.dispatch("saveMotorista", values);
    isLoading.value = false;
    helpers.mensagemSucesso(
      `Motorista ${values.razao_social} cadastrado(a) com sucesso.`
    );
    typeof onUpdate === "function" &&
      onUpdate({ ["a03_ukey"]: motorista.ukey });
    await carregaMotoristasVinculados();

    typeof onUpdate === "function" &&
      onUpdate({ ["celular"]: motorista.celular });
    typeof onUpdate === "function" &&
      onUpdate({ ["ddi"]: motorista.ddi ? motorista.ddi : null });

    isLoading.value = false;
    modalNovoMotoristaShow.value = false;
    modalNovoMotoristaPasso.value = 1;
    modalNovoMotorista.value = {
      ...novoMotorista(),
      e_estrangeiro: values.e_estrangeiro,
    };
  } catch (err: any) {
    isLoading.value = false;
    console.log(err);
  }
};

const onUpdate = inject(FormValidatedUpdateKey);

const ddis = computed(() => store.state?.ddis ?? []);

const onValidateMotorista = async (values: Motorista) => {
  if (values.e_estrangeiro == 0) {
    if (values.cpf_cnpj.length < 11) {
      helpers.mensagemErro("O CPF precisa ter ao menos 11 dígitos.");
      return;
    }
  }

  const { data } = await axios.post(
    "/portalagendamentos/valida-motorista",
    values
  );

  if (data != "error") {
    modalNovoMotoristaShow.value = false;
    await carregaMotoristasVinculados();
    typeof onUpdate === "function" && onUpdate({ ["a03_ukey"]: data });
    const motorista = motoristas.value.find((i) => i.value == data);
    if (motorista?.celular) {
      typeof onUpdate === "function" &&
        onUpdate({ ["celular"]: motorista.celular });
    }
    if (usuario_externo.value) {
      typeof onUpdate === "function" &&
        onUpdate({ ["ddi"]: motorista?.ddi ?? null });
    }
    if (values.e_estrangeiro == 0) {
      helpers.mensagemSucesso(
        "Motorista com este CPF já possui cadastro e foi vinculado a você."
      );
    } else {
      helpers.mensagemSucesso(
        "Motorista com este Celular/DDI já possui cadastro e foi vinculado a você."
      );
    }
    return;
  }

  if (values.e_estrangeiro == 1) {
    modalNovoMotorista.value = {
      ...values,
      razao_social: values.cpf_cnpj,
      cpf_cnpj: "",
    };
    modalNovoMotoristaPasso.value = 2;
    return;
  }
  modalNovoMotorista.value = values;
  modalNovoMotoristaPasso.value = 2;
};

return (_ctx: any,_cache: any) => {
  const _component_t_button = _resolveComponent("t-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["relative", __props.tclass])
    }, [
      (_unref(usuario_externo))
        ? (_openBlock(), _createBlock(SelectInput, {
            key: 0,
            tclass: "w-full",
            label: "Motorista",
            name: "a03_ukey",
            items: _unref(motoristas),
            onChange: onUpdateMotorista
          }, null, 8, ["items"]))
        : (_openBlock(), _createBlock(Bobjeto, {
            key: 1,
            name: "a03_ukey",
            name_term: "motorista",
            label: "Motorista",
            onAfterUpdate: preencheDadosDoMotorista,
            onOnLoadObject: preencheDadosDoMotorista,
            searchIn: [
        {
          campo: 'cpf_cnpj',
          reRemove: /[^0-9]/g,
          suffix: '%',
        },
        {
          campo: 'nome_fantasia',
          suffix: '%',
        },
        {
          campo: 'razao_social',
          suffix: '%',
        },
      ],
            objeto: "parceiros",
            tclass: "w-full",
            includes: "contatosProfissionais",
            "condicao-fixa": [
        {
          campo: 'e_motorista',
          operador: '=',
          valor: '1',
        },
        {
          campo: 'status_parceiro',
          operador: '=',
          valor: '1',
        },
      ],
            order: "razao_social"
          }, {
            exibicao: _withCtx(({ item }: any) => [
              item
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(item.razao_social) + " " + _toDisplayString(` - ${_unref(helpers).formatCpfCnpj(item.cpf_cnpj)}`), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })),
      _createVNode(_component_t_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
        (modalNovoMotorista.value = _unref(novoMotorista)()), (modalNovoMotoristaShow.value = true)
      )),
        size: "sm",
        class: "absolute top-0 right-1"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Novo motorista")
        ]),
        _: 1
      })
    ], 2),
    _createVNode(DialogModal, {
      show: modalNovoMotoristaShow.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (modalNovoMotoristaShow.value = false))
    }, {
      title: _withCtx(() => [
        _createVNode(ListHeader, { label: "Novo Motorista" })
      ]),
      content: _withCtx(() => [
        (modalNovoMotoristaShow.value && modalNovoMotoristaPasso.value == 1)
          ? (_openBlock(), _createBlock(FormValidated, {
              key: 0,
              "initial-values": modalNovoMotorista.value,
              "hide-buttons": true,
              onSave: onValidateMotorista
            }, {
              form: _withCtx(({ values }) => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(InputCheck, {
                    name: "e_estrangeiro",
                    tclass: "md:w-full",
                    label: "Não é do Brasil?"
                  }),
                  (values.e_estrangeiro == 0)
                    ? (_openBlock(), _createBlock(InputText, {
                        key: 0,
                        name: "cpf_cnpj",
                        tclass: "md:w-full",
                        label: "CPF"
                      }))
                    : _createCommentVNode("", true),
                  (values.e_estrangeiro == 1)
                    ? (_openBlock(), _createBlock(SelectInput, {
                        key: 1,
                        label: "País do Celular (DDI)",
                        name: "ddi",
                        tclass: "md:w-full",
                        items: _unref(ddis)
                      }, null, 8, ["items"]))
                    : _createCommentVNode("", true),
                  _createVNode(InputText, {
                    name: "celular",
                    tclass: "md:w-full",
                    label: `Celular ${
                values.ddi
                  ? `+${_unref(ddis).find((i) => i.value == values.ddi)?.ddi} ${
                      values.celular
                    }`
                  : ''
              }`,
                    mascara: 
                values.e_estrangeiro == 1 ? '999999999999' : '(99)99999-9999'
              
                  }, null, 8, ["label", "mascara"]),
                  (modalNovoMotoristaPasso.value == 1)
                    ? (_openBlock(), _createBlock(_component_t_button, {
                        key: 2,
                        class: "ml-3",
                        type: "submit"
                      }, {
                        default: _withCtx(() => [
                          (isLoading.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "sync-alt",
                                  spin: ""
                                }),
                                _createTextVNode(" Validando...")
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_4, "Validar motorista"))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["initial-values"]))
          : _createCommentVNode("", true),
        (modalNovoMotoristaShow.value && modalNovoMotoristaPasso.value == 2)
          ? (_openBlock(), _createBlock(FormValidated, {
              key: 1,
              "initial-values": modalNovoMotorista.value,
              "hide-buttons": true,
              onSave: onSubmitMotorista,
              validation: {
          razao_social: 'required',
        }
            }, {
              form: _withCtx(({ values }) => [
                _createElementVNode("div", _hoisted_5, [
                  (values.e_estrangeiro == 0)
                    ? (_openBlock(), _createBlock(InputText, {
                        key: 0,
                        name: "cpf_cnpj",
                        tclass: "md:w-full",
                        label: "CPF"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(InputText, {
                    name: "razao_social",
                    tclass: "md:w-full",
                    label: "Nome"
                  }),
                  (values.e_estrangeiro == 1)
                    ? (_openBlock(), _createBlock(SelectInput, {
                        key: 1,
                        label: "País do Celular (DDI)",
                        name: "ddi",
                        tclass: "md:w-full",
                        items: _unref(ddis)
                      }, null, 8, ["items"]))
                    : _createCommentVNode("", true),
                  _createVNode(InputText, {
                    name: "celular",
                    tclass: "md:w-full",
                    label: `Celular ${
                values.ddi
                  ? `+${_unref(ddis).find((i) => i.value == values.ddi)?.ddi} ${
                      values.celular
                    }`
                  : ''
              }`,
                    mascara: 
                values.e_estrangeiro == 1 ? '99999999999' : '(99)99999-9999'
              
                  }, null, 8, ["label", "mascara"]),
                  _hoisted_6,
                  _hoisted_7,
                  _hoisted_8,
                  _createVNode(_component_t_button, {
                    class: "ml-3",
                    type: "submit"
                  }, {
                    default: _withCtx(() => [
                      (isLoading.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "sync-alt",
                              spin: ""
                            }),
                            _createTextVNode(" Salvando...")
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_10, "Salvar Motorista"))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["initial-values"]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_t_button, {
          color: "gray",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (modalNovoMotoristaShow.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Fechar")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})